<!-- <h1 class="h3 mb-3">Credit Report Summary Results</h1> -->

<div class="search-results">
  <p class="nav-back">
    <a class="nav-back__link" routerLink="/credit-report-summary-search">Back to Search</a>
  </p>
  <div class="card">
    <div class="card__section">
      <div class="row align-bottom">
        <div class="columns">
          <!-- <h1 class="typography--display1">Summary</h1> -->
          <h1 class="card__title card__title--large">Credit Report Summary</h1>
        </div>
        <div class="columns shrink">
          <button class="btn btn--hollow btn--tiny" type="button" (click)="onDownloadAll()">Download All</button>
        </div>
      </div>
    </div>
    <div class="card__section">
      <div class="display-options">
        <div class="display-options__count">
          Showing {{ (searchResultsState$ | async).pagingSorting.pageSize * ((searchResultsState$ | async).pagingSorting.currentPage - 1) + 1 }} -
          {{
            (searchResultsState$ | async).pagingSorting.pageSize > (searchResultsState$ | async).pagingSorting.totalCount
              ? (searchResultsState$ | async).pagingSorting.totalCount
              : (searchResultsState$ | async).pagingSorting.pageSize * (searchResultsState$ | async).pagingSorting.currentPage
          }}
          of
          {{ (searchResultsState$ | async).pagingSorting.totalCount }}
        </div>
        <label class="display-options__per-page">
          Show
          <select (change)="setPageSize($event.target.value)">
            <option value="15" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 15">15</option>
            <option value="25" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 25">25</option>
            <option value="50" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 50">50</option>
            <option value="100" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 100">100</option>
            <option value="200" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 200">200</option>
          </select>
        </label>
        <!--<input type="text" class="display-options__filter" placeholder="Type to filter..." aria-label="Type to filter">-->
        <div class="display-options__filter"></div>
        <div class="display-options__pagination">
          <ul class="pagination" role="navigation" aria-label="Pagination">
            <!--<li class="pagination__previous disabled">Previous<span class="show-for-sr"> page</span></li>-->
            <li class="pagination__previous" [class.disabled]="(searchResultsState$ | async).pagingSorting.currentPage <= 1">
              {{ (searchResultsState$ | async).pagingSorting.currentPage <= 1 ? 'Previous' : '' }}
              <a *ngIf="(searchResultsState$ | async).pagingSorting.currentPage > 1" aria-label="Previous page" (click)="prevPage()"
                >Previous<span class="show-for-sr"> page</span></a
              >
            </li>
            <li class="pagination__current">
              <span class="show-for-sr">You are on page </span>
              {{ (searchResultsState$ | async).pagingSorting.currentPage }}
            </li>
            <li aria-hidden="true">of</li>
            <li>
              <a aria-label="Page 10" (click)="lastPage()">{{ (searchResultsState$ | async).pagingSorting.totalPages }}</a>
            </li>
            <li
              class="pagination__next"
              [class.disabled]="(searchResultsState$ | async).pagingSorting.currentPage >= (searchResultsState$ | async).pagingSorting.totalPages"
            >
              {{ (searchResultsState$ | async).pagingSorting.currentPage >= (searchResultsState$ | async).pagingSorting.totalPages ? 'Next' : '' }}
              <a
                *ngIf="(searchResultsState$ | async).pagingSorting.currentPage < (searchResultsState$ | async).pagingSorting.totalPages"
                aria-label="Next page"
                (click)="nextPage()"
                >Next<span class="show-for-sr"> page</span></a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="full-page-spinner" [class.full-page-spinner--is-active]="(searchResultsState$ | async).loading || (downloadRequestFormState$ | async).loading">
      <div class="full-page-spinner__icon"></div>
    </div>

    <div class="card__section">
      <div class="table" role="table">
        <div role="rowgroup">
          <div class="table__row table__row--header" role="row">
            <span class="table__cell table__cell--align-left" role="columnheader">
              <button
                class="table__sorter-btn"
                (click)="sortBy('CreatedDateTime')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'CreatedDateTime' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'CreatedDateTime' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Date
              </button>
            </span>
            <span class="table__cell" role="columnheader">
              <button
                class="table__sorter-btn table__sorter-btn--sorted-asc"
                (click)="sortBy('BureauCall')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'BureauCall' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'BureauCall' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Bureau Call
              </button>
            </span>
            <span class="table__cell" role="columnheader">
              <button
                class="table__sorter-btn"
                (click)="sortBy('CreditFileFound')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'CreditFileFound' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'CreditFileFound' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                File Found
              </button>
            </span>
            <span class="table__cell table__cell--half" role="columnheader">
              <button
                class="table__sorter-btn"
                (click)="sortBy('FraudActivity')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'FraudActivity' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'FraudActivity' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Fraud
              </button>
            </span>
            <span class="table__cell table__cell--align-left" role="columnheader" title="Social Security Number">
              <button
                class="table__sorter-btn"
                (click)="sortBy('SocialSecurityNumber')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'SocialSecurityNumber' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'SocialSecurityNumber' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                SSN
              </button>
            </span>
            <span class="table__cell table__cell--align-left" role="columnheader">
              <button
                class="table__sorter-btn"
                (click)="sortBy('ApplicantFirstName')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'ApplicantFirstName' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'ApplicantFirstName' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                First Name
              </button>
            </span>
            <span class="table__cell table__cell--align-left" role="columnheader">
              <button
                class="table__sorter-btn"
                (click)="sortBy('ApplicantLastName')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'ApplicantLastName' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'ApplicantLastName' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Last Name
              </button>
            </span>
            <span class="table__cell table__cell--half" role="columnheader" title="Credit Score">
              <button
                class="table__sorter-btn"
                (click)="sortBy('CreditScore')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'CreditScore' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'CreditScore' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Score
              </button>
            </span>
            <span class="table__cell" role="columnheader">
              <button
                class="table__sorter-btn"
                (click)="sortBy('InstrumentType')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'InstrumentType' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'InstrumentType' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Instrument
              </button>
            </span>
            <span class="table__cell" role="columnheader">
              <button
                class="table__sorter-btn"
                (click)="sortBy('RentalDeposit')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'RentalDeposit' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'RentalDeposit' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Rental Deposit
              </button>
            </span>
            <span class="table__cell table__cell--one-half" role="columnheader">
              <button
                class="table__sorter-btn"
                (click)="sortBy('CreditReportSource')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'CreditReportSource' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'CreditReportSource' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Source
              </button>
            </span>
            <span class="table__cell table__cell--half" role="columnheader">
              <button
                class="table__sorter-btn"
                (click)="sortBy('StoreId')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'StoreId' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'StoreId' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Store
              </button>
            </span>
            <span class="table__cell" role="columnheader">
              <button
                class="table__sorter-btn"
                (click)="sortBy('EmployeeId')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'EmployeeId' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'EmployeeId' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Employee
              </button>
            </span>
            <span class="table__cell" role="columnheader">
              <button
                class="table__sorter-btn"
                (click)="sortBy('ApprovalNumber')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'ApprovalNumber' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'ApprovalNumber' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Approval #
              </button>
            </span>
            <span class="table__cell table__cell--half" role="columnheader"> Action </span>
          </div>
        </div>
        <div role="rowgroup">
          <a
            class="table__row ng-scope"
            role="row"
            *ngFor="let creditReport of (searchResultsState$ | async).response?.results; odd as isOdd; last as isLast"
            [class.table__row--alt]="isOdd"
            [class.table__row--last]="isLast"
          >
            <span class="table__cell table__cell--align-left" role="cell" [title]="creditReport.createdDate | date : 'MM/dd/yyyy hh:mm:ss a'">
              {{ creditReport.createdDate | date : 'MM/dd/yyyy hh:mm:ss a' }}
            </span>
            <span class="table__cell" role="cell">{{ creditReport.bureauCall ? 'Yes' : 'No' }}</span>
            <span class="table__cell" role="cell">{{ creditReport.creditFileFound ? 'Yes' : 'No' }}</span>
            <span class="table__cell table__cell--half" role="cell">{{ creditReport.fraudActivity ? 'Yes' : 'No' }}</span>
            <span class="table__cell table__cell--align-left" role="cell">{{ creditReport.socialSecurityNumber }}</span>
            <span class="table__cell table__cell--align-left" role="cell">{{ creditReport.applicantFirstName }}</span>
            <span class="table__cell table__cell--align-left" role="cell">{{ creditReport.applicantLastName }}</span>
            <span class="table__cell table__cell--half" role="cell">{{ creditReport.creditScore }}</span>
            <span class="table__cell" role="cell">{{ creditReport.instrumentType }}</span>
            <span class="table__cell" role="cell">{{ (creditReport.rentalDeposit ? creditReport.rentalDeposit : 0) | currency : 'USD' }}</span>
            <span class="table__cell table__cell--one-half" role="cell">
              {{ creditReport.creditReportSource === 0 ? 'OnlineRentals' : 'Store' }}
            </span>
            <span class="table__cell table__cell--half" role="cell">{{ creditReport.storeId }}</span>
            <span class="table__cell" role="cell">{{ creditReport.employeeId }}</span>
            <span class="table__cell" role="cell">{{ creditReport.approvalNumber }}</span>
            <span class="table__cell table__cell--half" role="cell">
              <button class="btn btn--hollow btn--tiny" (click)="downloadCreditReport(creditReport.logId)"><span class="icon icon--download"></span></button>
            </span>
          </a>
        </div>
      </div>
    </div>
    <div class="card__section">
      <div class="display-options">
        <div class="display-options__count">
          Showing {{ (searchResultsState$ | async).pagingSorting.pageSize * ((searchResultsState$ | async).pagingSorting.currentPage - 1) + 1 }} -
          {{
            (searchResultsState$ | async).pagingSorting.pageSize > (searchResultsState$ | async).pagingSorting.totalCount
              ? (searchResultsState$ | async).pagingSorting.totalCount
              : (searchResultsState$ | async).pagingSorting.pageSize * (searchResultsState$ | async).pagingSorting.currentPage
          }}
          of
          {{ (searchResultsState$ | async).pagingSorting.totalCount }}
        </div>
        <label class="display-options__per-page">
          Show
          <select (change)="setPageSize($event.target.value)">
            <option value="15" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 15">15</option>
            <option value="25" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 25">25</option>
            <option value="50" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 50">50</option>
            <option value="100" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 100">100</option>
            <option value="200" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 200">200</option>
          </select>
        </label>
        <!--<input type="text" class="display-options__filter" placeholder="Type to filter..." aria-label="Type to filter">-->
        <div class="display-options__filter"></div>
        <div class="display-options__pagination">
          <ul class="pagination" role="navigation" aria-label="Pagination">
            <!--<li class="pagination__previous disabled">Previous<span class="show-for-sr"> page</span></li>-->
            <li class="pagination__previous" [class.disabled]="(searchResultsState$ | async).pagingSorting.currentPage <= 1">
              {{ (searchResultsState$ | async).pagingSorting.currentPage <= 1 ? 'Previous' : '' }}
              <a *ngIf="(searchResultsState$ | async).pagingSorting.currentPage > 1" aria-label="Previous page" (click)="prevPage()"
                >Previous<span class="show-for-sr"> page</span></a
              >
            </li>
            <li class="pagination__current">
              <span class="show-for-sr">You are on page </span>
              {{ (searchResultsState$ | async).pagingSorting.currentPage }}
            </li>
            <li aria-hidden="true">of</li>
            <li>
              <a aria-label="Page 10" (click)="lastPage()">{{ (searchResultsState$ | async).pagingSorting.totalPages }}</a>
            </li>
            <li
              class="pagination__next"
              [class.disabled]="(searchResultsState$ | async).pagingSorting.currentPage >= (searchResultsState$ | async).pagingSorting.totalPages"
            >
              {{ (searchResultsState$ | async).pagingSorting.currentPage >= (searchResultsState$ | async).pagingSorting.totalPages ? 'Next' : '' }}
              <a
                *ngIf="(searchResultsState$ | async).pagingSorting.currentPage < (searchResultsState$ | async).pagingSorting.totalPages"
                aria-label="Next page"
                (click)="nextPage()"
                >Next<span class="show-for-sr"> page</span></a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
